
var angular: angular.IAngularStatic = require('angular');
import {Injectable, Inject} from 'ng-metadata/core';
import {PrimolyticsService, beacon} from '../../../analytics/primolytics.service';
import {PrimoExploreService} from "../../../primoExplore/primoExplore.service";
import {PermalinkService} from '../../actions/permalinkAction/permalink.service';
import {ConfigurationUtil} from '../../../nddUtils/configurationUtil.service';
import {MappingTablesCache} from '../../../mappingTablesCache/mappingTablesCache.service';
import {getVid} from '../../../appConfig/appConfigForward';

@Injectable()
export class QrCodeService {

    public _showQrCodeButton: boolean = false;

    constructor(private primolyticsService: PrimolyticsService,
                private primoExploreService: PrimoExploreService,
                private configurationUtil : ConfigurationUtil,
                private mappingTablesCache: MappingTablesCache, 
                private permalinkService: PermalinkService,
                @Inject('$mdDialog') private $mdDialog: angular.material.IDialogService,
                @Inject('$translate') private $translate: ng.translate.ITranslateService,
                @Inject('$location') private $location) {
        
        if((this.mappingTablesCache.findByProperties('View Properties', {source1: getVid(), source2: 'enable_qr', target: 'false'}).length === 0)){;
            this._showQrCodeButton = true;
        }
    }

    public openQrDialogForUrl(url) {
        let templateString =  '<md-dialog class="login-dialog light-on-dark-dialog tabbed-dialog" aria-label="'+ this.getQRAriaLabel() +'"> ' +
                              '<prm-qr-code ui-type="dialog"></prm-qr-code>' +
                              '</md-dialog>';

        this.$mdDialog.show({
            template: templateString,
            bindToController: true,
            onComplete: () => {
                this.setFocusOnElement('copyQrCodeDialogLink', true);
            },
            controllerAs: 'ctrl',
            controller : function(){},
            locals:{
            },
        });
    }
    
    public setFocusOnElement(selector, hasId){
        let element = (hasId) ? document.getElementById(selector) : document.querySelector(selector);
        if(element){
            element.focus();
        }
    }
    
    public getQRAriaLabel() {
        return this.$translate.instant('general.QRScanCode');
    }

    public copyQrUrlToClipboard(url) {
        let input = document.createElement('input');
        input.setAttribute('value', url);
        document.body.appendChild(input);
        input.setSelectionRange(0, 99999); /*For mobile devices*/
        input.select();
        document.execCommand('copy');
        document.body.removeChild(input);
    }
    
    public copyQrImageToClipboard(qrImageElementId) {
        let range;
        let selection;
        let qrImage = document.getElementById(qrImageElementId)
        
        if(qrImage){
            if (document.body.createRange)
            {
                range = document.createRange();
                range.selectNode(qrImage);
                window.getSelection().addRange(range);
            }
            else if (window.getSelection)
            {
                selection = window.getSelection();
                range = document.createRange();
                range.selectNode(qrImage);
                selection.removeAllRanges();
                selection.addRange(range);
            }
            document.execCommand('copy');
            window.getSelection().removeAllRanges();
        }
    }

    public showQrCodeButton() {
        return this._showQrCodeButton;
    }

    public sendQrCodeBeacon() {
        this.primolyticsService.doBeaconReport({
            'p': 'general',
            'op': 'QRLink'
        }, null, this.primolyticsService.getTimestamp());
    }

    public removeBackgroundDarkClass() {
        this.primoExploreService.dimScreen( false );
    }

}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/topbar/qrCode/qrCode.service.ts